export const ceresTextureSrc = "https://raw.githubusercontent.com/n-nicholas-s/RAW/main/moon_final.jpg";
export const ceresDisplacementSrc = "https://raw.githubusercontent.com/n-nicholas-s/RAW/main/moon_final.jpg";

export const sectionIds = ["","II.", "III.", "IV.", "V.", "VI."] as const;
export const sections = [
  "",
  "about us",
  "our menu",
  "wareisthehaus",
  "our gallery",
  "collaborations",
] as const;

export type Section = typeof sections[number];